// ??? Adding Contract Search dialog to this for now.  This needs refactoring. MLE ???

import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSearchComponent } from '@Work/Accounts/proprietary/controls/inline-search.component';
import { SearchDialogModule } from '@Work/Accounts/proprietary/controls/search-dialog.module';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { FocusDirective } from '@Shared/Directives/proprietary/auto-focus.directive';
import { DocumentImportModule } from '../controls/document-controls/document-import.module';
import { ForcedSearchComponent } from '../controls/forced-search.component';
import { InputControlModule } from '../controls/input-control.module';
import { DirectiveModule } from '../../../../../Shared/Directives/proprietary/directive.module';
import { ActionSearchDialogComponent } from './action-search-dialog/action-search-dialog.component';
import { AgreementSearchDialogComponent } from './agreement-search-dialog/agreement-search-dialog.component';
import { BrokerSearchDialogComponent } from './broker-search-dialog.component';
import { ClaimSearchDialogComponent } from './claim-search-dialog.component';
import { ClassCodeSearchDialogComponent } from './classCode-search-dialog.component';
import { CodeSetSearchDialogComponent } from './codeSet-search-dialog.component';
import { ConditionSearchDialogComponent } from './condition-search-dialog.component';
import { ContractInterestThirdPartySearchDialogComponent } from './contract-interest-third-party-search-dialog.component';
import { ContractProfileSearchDialogComponent } from './contract-profile-search-dialog.component';
import { ContractSearchDialogComponent } from './contract-search-dialog.component';
import { DocumentSearchDialogComponent } from './document-search-dialog.component';
import { EmployeeSearchDialogComponent } from './employee-search-dialog.component';
import { EntitySearchDialogComponent } from './entity-search-dialog.component';
import { FormSearchDialogComponent } from './form-search-dialog.component';
import { InvoiceSearchDialogComponent } from './invoice-search-dialog.component';
import { PartyAgreementSearchDialogComponent } from './party-agreement-search-dialog.component';
import { ProviderSearchDialogComponent } from './provider-search-dialog.component';
import { ServiceSearchDialogComponent } from './service-search-dialog/service-search-dialog.component';
import { StatementSearchDialogComponent } from './statement-search-dialog.component';
import { SupplierSearchDialogComponent } from './supplier-search-dialog.component';
import { TeamSetSearchDialogComponent } from './team-set-search-dialog.component';
import { WorkgroupSearchDialogComponent } from './workgroup-search-dialog.component';

@NgModule({
    imports: [
        SharedPageModule,
        SearchDialogModule,
        NgbTooltipModule,
        DirectiveModule,
        InputControlModule,
        DocumentImportModule
    ],
    declarations: [
        EntitySearchDialogComponent,
        ContractSearchDialogComponent,
        ClaimSearchDialogComponent,
        InlineSearchComponent,
        FocusDirective,
        AgreementSearchDialogComponent,
        PartyAgreementSearchDialogComponent,
        FormSearchDialogComponent,
        ConditionSearchDialogComponent,
        TeamSetSearchDialogComponent,
        DocumentSearchDialogComponent,
        ContractProfileSearchDialogComponent,
        EmployeeSearchDialogComponent,
        WorkgroupSearchDialogComponent,
        ServiceSearchDialogComponent,
        ActionSearchDialogComponent,
        BrokerSearchDialogComponent,
        SupplierSearchDialogComponent,
        CodeSetSearchDialogComponent,
        ClassCodeSearchDialogComponent,
        ContractInterestThirdPartySearchDialogComponent,
        InvoiceSearchDialogComponent,
        StatementSearchDialogComponent,
        ProviderSearchDialogComponent,
        ForcedSearchComponent
    ],
    providers: [
        //DataService  -- declare in Component!
    ],
    exports: [
        EntitySearchDialogComponent,
        ContractSearchDialogComponent,
        ClaimSearchDialogComponent,
        InlineSearchComponent,
        FocusDirective,
        AgreementSearchDialogComponent,
        PartyAgreementSearchDialogComponent,
        FormSearchDialogComponent,
        ConditionSearchDialogComponent,
        TeamSetSearchDialogComponent,
        DocumentSearchDialogComponent,
        ContractProfileSearchDialogComponent,
        EmployeeSearchDialogComponent,
        WorkgroupSearchDialogComponent,
        ServiceSearchDialogComponent,
        ActionSearchDialogComponent,
        BrokerSearchDialogComponent,
        SupplierSearchDialogComponent,
        CodeSetSearchDialogComponent,
        ClassCodeSearchDialogComponent,
        ContractInterestThirdPartySearchDialogComponent,
        InvoiceSearchDialogComponent,
        StatementSearchDialogComponent,
        ProviderSearchDialogComponent,
        ForcedSearchComponent
    ]
})
export class EntitySearchDialogModule { }
